import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

// Route değişiminde üste kaydırma gibi Lenis dışından tetiklenen işlemler için
// aktif Lenis instance'ına erişim sağlar. Lenis mount edilmemişse (ör. admin sayfaları) null döner.
export function getLenis() {
  return lenisInstance;
}

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisInstance = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
}
